import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'
import baseApi from './slices/api/baseApi'
import app from './slices/app'
// import {createLogger} from 'redux-logger'
import rtkQueryErrorHandler from './middleware/rtkQueryErrorHandler'

// const logger = createLogger({
//     predicate: (getState, action) => action.type !== 'SET_PROCESSING',
// })

const store = configureStore({
    reducer: {
        [baseApi.reducerPath]: baseApi.reducer,
        app,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            // .concat(logger)
            .concat(baseApi.middleware)
            .concat(rtkQueryErrorHandler),
})

setupListeners(store.dispatch)

export * from './slices/api/uploadsApi'
export * from './slices/api/accountReportApi'
export * from './slices/api/faultLogApi'
export * from './slices/api/invoiceApi'
export * from './slices/api/metersReadingApi'
export * from './slices/api/ratesApi'
export * from './slices/api/metersApi'
export * from './slices/api/consumersApi'
export * from './slices/api/structuresApi'
export * from './slices/api/authApi'
export * from './slices/api/usersApi'
export * from './slices/api/accountsApi'
export * from './slices/api/configApi'
export * from './slices/api/permissionsApi'
export * from './slices/api/paymentsApi'
export * from './slices/api/queueApi'
export * from './slices/api/emailBroadcastsApi'
export * from './slices/app'

export default store
